module.exports = __webpack_public_path__ + "img/google-messages.37fa1fa9.png";